import { GET, POST, PUT } from '../request'

export const preguntaSimple = ({ pregunta }) =>
  POST('/api/profes/interno/ia/consulta-barbeibot/simple', {}, { pregunta })

export const preguntaImagen = ({ pregunta, image }) => {
  const formData = new FormData()
  formData.append('pregunta', pregunta)
  if (image) formData.append('image', image, 'image.jpg')
  return PUT(
    '/api/profes/interno/ia/consulta-barbeibot/image',
    {},
    formData,
    true
  )
}

export const preguntaExperimental = ({ pregunta, image }) => {
  const formData = new FormData()
  formData.append('pregunta', pregunta)
  if (image) formData.append('image', image, 'image.jpg')
  return PUT(
    '/api/profes/interno/ia/consulta-barbeibot/experimental',
    {},
    formData,
    true
  )
}
export const preguntaAvanzada = ({
  pregunta,
  images = [],
  archivos = [],
  model
}) => {
  const formData = new FormData()
  formData.append('pregunta', pregunta)
  formData.append('modelo', model)
  images.forEach(img => formData.append('images', img, img.name || 'image.jpg'))
  archivos.forEach(file => formData.append('archivos', file, file.name))
  return POST(
    '/api/profes/interno/ia/consulta-barbeibot/avanzada',
    {},
    formData,
    true
  )
}

export const createConversacion = ({ pregunta }) =>
  POST(
    '/api/profes/interno/ia/consulta-barbeibot/conversacion',
    {},
    { pregunta }
  )
export const updateConversacion = ({ id, pregunta }) =>
  PUT(
    '/api/profes/interno/ia/consulta-barbeibot/conversacion/update',
    {},
    { id, pregunta }
  )

export const getConsulta = id =>
  GET('/api/profes/interno/ia/consulta-barbeibot', { id })
export const getConsultaList = mes =>
  GET('/api/profes/interno/ia/consulta-barbeibot/list', { mes })
